<nav
  class="property-tabs-nav"
  aria-label="Property details navigation"
>
  <div class="property-tabs-list">

    @for (tab of tabs; track tab.id) {

      <button
        type="button"
        (click)="selectTab(tab.id)"
        #tabButton
        [attr.aria-selected]="activeTab === tab.id"
        [class.active]="activeTab === tab.id"
        class="property-tab"
      >

        <!-- Building -->
        @if (tab.icon === 'building') {
          <svg
            class="property-tab-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3 21h18M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16M9 7h1m4 0h1M9 11h1m4 0h1M9 15h1m4 0h1M9 21v-3h6v3"
            />
          </svg>
        }

        <!-- Sparkles -->
        @if (tab.icon === 'sparkles') {
          <svg
            class="property-tab-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 3l1.2 3.8L17 8l-3.8 1.2L12 13l-1.2-3.8L7 8l3.8-1.2L12 3z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19 13l.7 2.3L22 16l-2.3.7L19 19l-.7-2.3L16 16l2.3-.7L19 13z"
            />
          </svg>
        }

        <!-- Chart -->
        @if (tab.icon === 'chart') {
          <svg
            class="property-tab-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4 19V5M4 19h16M8 16v-5M12 16V8M16 16v-3M20 16V6"
            />
          </svg>
        }

        <!-- Location -->
        @if (tab.icon === 'location') {
          <svg
            class="property-tab-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 21s7-5.2 7-11a7 7 0 1 0-14 0c0 5.8 7 11 7 11z"
            />
            <circle cx="12" cy="10" r="2.5" />
          </svg>
        }

        <span>{{ tab.label }}</span>

      </button>

    }

  </div>
</nav>